import RefDataCrudPage from './RefDataCrudPage'
import { employeeTypesApi } from '../api/lookupApi'

export default function EmployeeTypesPage() {
  return <RefDataCrudPage api={employeeTypesApi} i18nPrefix="optionDefs.employeeTypes" />
}
